// @module TavanoTeam.CapSciExtensions.CSSearchSpringExt
define('TavanoTeam.CapSciExtensions.CSSearchSpringExt.OrderWizard.Module.Confirmation'
,	[
		'OrderWizard.Module.Confirmation'
	,	'OrderWizard.Module.CartSummary'
	,	'Profile.Model'

	,	'SC.Configuration'

	,	'underscore'
	,	'jQuery'
	]
,   function (
		OrderWizardModuleConfirmation
	,	OrderWizardCartSummary
	,	ProfileModel

	,	Configuration

	,	_
	,	jQuery
	)
{
	'use strict';

	return  {
		loadSearchSpringConfirmation: function loadSearchSpringConfirmation (container)
		{
            _.extend(OrderWizardCartSummary.prototype, {
				initialize: _.wrap(OrderWizardCartSummary.prototype.initialize, function(fn)
				{
					var origInit = fn.apply(this, _.toArray(arguments).slice(1))
					,	self = this;

					var a = ProfileModel.getInstance();

					console.log("a", a);

					this.cartModel = this.wizard.model;
					this.lines = this.cartModel.get('lines').models;
					this.itemArr = [];

					_.each(this.lines, function(line)
					{
						var items = line.get('item')
						,	sku = items.get('_sku');

						self.itemArr.push({
							sku: sku
						,	qty: line.get('quantity').toString()
						,	price: line.get('rate').toString()
						});
					});

					return origInit;
				})
			,	render: _.wrap(OrderWizardCartSummary.prototype.render, function(fn)
				{
					var origRender = fn.apply(this, _.toArray(arguments).slice(1))
					,	self = this;

					if(this.model.get('confirmation').get('internalid'))
					{
						this.loadIntelliSuggestOrderConfirmation(self.itemArr);
					}

					return origRender;
				})
			,	loadIntelliSuggestOrderConfirmation: function(items)
				{
					IntelliSuggest.init({siteId:"ejxf37"});

					_.each(items, function(item)
					{
						IntelliSuggest.haveItem(item);
					});

					IntelliSuggest.inSale({});
					
				}
            });
		}
	};
});
